import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import store from '../store' // your vuex store 
import i18n from '../i18n'

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  // mode: 'history',
  routes,
  linkActiveClass: "active"
});

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)){
    if(store.state.auth.loggedIn){
      next();
    }else{
      next({path: "/login"})
    }
  }else{
      next();
  }

  let language = to.params.lang;
  if (!language) {
     language = 'en'
  }
  i18n.locale = language
});
export default router;
